import { useDispatch } from "react-redux";
import { KindeProvider } from "@kinde-oss/kinde-auth-react";
import { setSessionToken, setUser } from "../features/auth/authSlice";

export function KindeWrapper({ children }) {
  const kindeClientId = process.env.REACT_APP_KINDE_CLIENT_ID;
  const kindeLogoutUrl = process.env.REACT_APP_KINDE_LOGOUT_URI;
  const kindeRedirectUri = process.env.REACT_APP_KINDE_REDIRECT_URI;
  const kindeLoginUrl = process.env.REACT_APP_KINDE_DOMAIN;
  const kindeAudience = process.env.REACT_APP_KINDE_AUDIENCE;

  const dispatch = useDispatch();

  if (
    !kindeClientId ||
    !kindeLogoutUrl ||
    !kindeRedirectUri ||
    !kindeLoginUrl
  ) {
    console.error("Missing Kinde environment variables");
    return (
      <div>
        Error: Kinde is not configured. Please check environment variables.
      </div>
    );
  }

  return (
    <KindeProvider
      clientId={kindeClientId}
      domain={kindeLoginUrl}
      logoutUri={window.location.origin}
      redirectUri={window.location.origin}
      audience={kindeAudience}
      callbacks={{
        onSuccess: async (user, state, context) => {
          // Save user and user token to state.
          // email : "test@gmail.com"
          // familyName : "Doe"
          // givenName : "John"
          // id : "kp_test"
          // picture: "https://lh3.googleusercontent.com/a/testtest"

          const token = await context?.getAccessToken();

          dispatch(setUser(user));
          dispatch(setSessionToken(token));

          const callbackEntryPaths = ["/", "/login", "/pba-log"];
          if (callbackEntryPaths.includes(window.location.pathname)) {
            window.location.replace("/my-record");
          }

          // console.log("kindeAuth:onSuccess", user, state, context);
        },
        onError: (error, state, context) => {
          // console.log("kindeAuth:onError", error, state, context);
        },
        onEvent: (event, state, context) => {
          // Log auth events for debugging
          // Remove user/token from state on logout?
          // console.log("kindeAuth:onEvent", event, state, context);
        },
      }}
    >
      {children}
    </KindeProvider>
  );
}
